import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {fromEvent} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Directive({
    selector: '[appDoisCliques]',
    standalone: false
})
export class DoisCliquesDirective implements OnInit, OnDestroy {

    @Input() id: any;

    $event: any;

    constructor(private el: ElementRef, private router: Router) {
  }


    ngOnInit() {
        this.$event = fromEvent(this.el.nativeElement, 'click');

       /* this.$event.pipe.buffer(debounceTime(250))
            .map(list => list.length)
            .filter(length => length >= 2)
            .subscribe(totalClicks => {
                console.log(`multi clicks total: ${totalClicks}`);
            });*/
    }

    ngOnDestroy() {
       // this.$event.unsubscribe()
    }


    handleClick() {
        let timeout: any = null

        if(timeout) {
            this.acao.bind(this)
        } else {
            timeout = setTimeout(()=> clearTimeout(timeout), 1000)
        }
    }


    acao() {
       this.router.navigate([`/lancamento-conta-caixa/${this.id}`])
    }

}